// extracted by mini-css-extract-plugin
export default {"emoji":"emoji__VJuG8"};